import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/common/PageHeader";
import { getSettingsSections } from "../../Data/Data";
import { useRestaurantDetails } from "../../context/RestaurantDetailsContext";

const SettingsHub = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const { restaurantDetails } = useRestaurantDetails() || {};

  const features = restaurantDetails?.restaurant?.features || {};
  const sidebarPermissions = restaurantDetails?.restaurant?.sidebarPermissions || null;

  const sections = getSettingsSections(role, features, sidebarPermissions);

  return (
    <div className="space-y-6 pb-8">
      <PageHeader
        showBackButton={false}
        title="Settings"
        subtitle="Manage products, sales, users and restaurant configuration"
      />

      {sections.map((section) => (
        <div
          key={section.heading}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4"
        >
          <h2 className="text-base font-semibold text-gray-900 mb-3">
            {section.heading}
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
            {section.items.map(({ id, heading, emoji, link }) => (
              <button
                key={id}
                onClick={() => navigate(link)}
                className="flex flex-col items-center gap-1.5 p-3 rounded-xl border bg-gray-50 border-gray-100 text-gray-700
                           hover:bg-gray-100 hover:scale-105 active:scale-95 transition-transform duration-150"
              >
                <span className="text-xl">{emoji}</span>
                <span className="text-xs font-semibold text-center leading-tight">
                  {heading}
                </span>
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SettingsHub;
